import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=7ed1dc34&scoped=true&"
import script from "./AddToCartButton.vue?vue&type=script&lang=js&"
export * from "./AddToCartButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed1dc34",
  null
  
)

export default component.exports